import React, { useState, useEffect, forwardRef } from "react";
import { useRememberPassword } from "../hooks/use-remember-password";

/**
 * Componente CheckBox que guarda el usuario y contraseña en el storage
 * @param {Object} props - Propiedades del componente.
 * @param {string} props.name - texto del checkbox
 * @param {import("react").Ref} props.userRef - referencia del input de usuario
 * @param {import("react").Ref} props.passwordRef - referencia del input de contraseña
 * @param {updateFuction} props.updateFuction - Función que cambia el usuario y la contraseña de los inputs
 * @returns {JSX.Element} RememberPassword 
 */
export const RememberPassword = forwardRef(({ name, userRef, passwordRef, updateFuction }) => {
    const [check, setCheck] = useState(false);
    const passwordManager = useRememberPassword();
    const checkActive = passwordManager?.active;
    const storageName = passwordManager?.user;
    const storagePassword = passwordManager?.password;

    /**Si hay datos en el storage actualiza los datos de los inputs userName y password. tambien activa el check */
    useEffect(() => {
        if (updateFuction && checkActive) {
            setCheck(checkActive)
            updateFuction({user: storageName, pass:storagePassword})
        }
    }, [checkActive])


    /**Si se actualiza los campos o el check se actualizan los datos en el storage */
    useEffect(() => {
        if (userRef.current.value !== ""  && check) {
            passwordManager.setCredentials({ user: userRef.current.value, password: passwordRef.current.value })
        } 
    }, [userRef?.current?.value, check])

    return (
        <label
            className="d-flex align-items-center pointer my-2"
            role="checkbox"
            checked={check}
            aria-checked={check}
        >
            <input
                type="checkbox"
                className="remember-checkbox focusable-red "
                checked={check}
                onChange={(e) => {
                    if (e?.target?.checked && userRef.current.value !== "") {
                        passwordManager.setCredentials({ user: userRef.current.value, password: passwordRef.current.value })
                    } else {
                        passwordManager.removeCredentials()
                    }
                    setCheck(e?.target?.checked)
                }}

            />
            <i className="check"></i>
            <p className="ml-2 onbackground-primary--color">
                {name? name : 'Recordarme'}
            </p>
        </label>
    )
})